<template>
  <div class="px-5 py-1 pb-5 border border-gray-400 border-solid my-2">
    <div
      class="px-6 py-5 rounded-lg flex justify-between items-center cursor-pointer"
      @click="toggleAccordionManagerRequest"
      style="border-bottom: gray solid 1px"
    >
      <p class="text-dark text-left">
        <b>Información del gestor de la modificación</b>
      </p>
      <span
        class="h-5 w-5 m-2 flex justify-center items-center transition"
        :class="{ 'transform rotate-180': isOpenManagerRequest }"
      >
        <img src="@/assets/icons/arrow-down.svg" alt="" />
      </span>
    </div>

    <!-- Acordeón del gestor de la modificación -->
    <div v-if="isOpenManagerRequest" class="px-8 py-3">
      <div class="container mx-auto max-w-4xl px-4 mt-5">
        <div v-if="form.managed_data" class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Nombre completo"
              v-model="form.managed_data.full_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Correo electrónico"
              v-model="form.managed_data.email"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>

        <div v-if="form.managed_data" class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Tipo de identificación"
              v-model="form.managed_data.identification_type"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Número de identificación"
              v-model="form.managed_data.identification_number"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>

        <div v-else class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <p class="text-left">
              El usuario ingresó la información por su cuenta.
            </p>
          </div>
        </div>

        <div class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Fecha de actualización"
              v-model="form.creation_date"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="px-6 py-5 rounded-lg flex justify-between items-center cursor-pointer"
      @click="toggleAccordionRequest"
      style="border-bottom: gray solid 1px"
    >
      <p class="text-dark text-left">
        <b>Información del consumidor financiero</b>
      </p>
      <span
        class="h-5 w-5 m-2 flex justify-center items-center transition"
        :class="{ 'transform rotate-180': isOpenRequest }"
      >
        <img src="@/assets/icons/arrow-down.svg" alt="" />
      </span>
    </div>

    <!-- Acordeón de solicitud -->
    <div v-if="isOpenRequest" class="px-8 py-3">
      <div class="container mx-auto max-w-4xl px-4 mt-5">
        <div class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Nombres"
              v-model="form.first_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Apellidos"
              v-model="form.last_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>

        <div class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Tipo de identificación"
              v-model="form.tipo_id_cf_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Número de identificación"
              v-model="form.numero_id_CF"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>

        <div class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Fecha de nacimiento"
              v-model="form.birth_date"
              placeholder=""
              :disabled="true"
            />
            <BaseInput
              type="text"
              label="Dirección física"
              v-model="form.address"
              placeholder=""
              :disabled="true"
            />
          </div>
        </div>

        <div class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Número de teléfono"
              v-model="form.phone"
              placeholder=""
              :disabled="true"
            />
            <BaseInput
              type="text"
              label="Correo electrónico"
              v-model="form.email"
              placeholder=""
              :disabled="true"
            />
          </div>
        </div>

        <div class="flex flex-row gap-2">
          <div class="w-full grid md:grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Selecciones un departamento"
              v-model="form.department_name"
              placeholder=""
              :disabled="true"
            />
            <BaseInput
              type="text"
              label="Seleccione un municipio"
              v-model="form.municipio_name"
              placeholder=""
              :disabled="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="px-6 py-5 rounded-lg flex justify-between items-center cursor-pointer"
      @click="toggleAccordionHistorical"
      style="border-bottom: gray solid 1px"
    >
      <p class="text-dark text-left"><b>Histórico</b></p>
      <span
        class="h-5 w-5 m-2 flex justify-center items-center transition"
        :class="{ 'transform rotate-180': isOpenHistorical }"
      >
        <img src="@/assets/icons/arrow-down.svg" alt="" />
      </span>
    </div>

    <!-- Acordeón de histórico -->
    <div v-if="isOpenHistorical" class="px-8 py-3">
      <div class="container mx-auto max-w-4xl px-4 mt-5">
        <div class="flex flex-row gap-2 flex-wrap">
          <div
            v-if="form.historical.length > 0"
            v-for="history in form.historical"
            :key="history.id"
            class="w-full grid md:grid-cols-2 gap-2 content-center"
          >
            <BaseInput
              type="text"
              label="Fecha de actualización"
              v-model="history.creation_date"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <div id="view-detail">
              <button
                class="mt-10 border-blue bg-blue text-white hover:bg-blue-dark hover:text-white hover:border-blue-dark py-2 px-10 rounded-3xl"
                @click="viewDetail(history.id)"
              >
                Ver detalles
              </button>
            </div>
          </div>
          <div
            v-if="form.historical.length <= 0"
            class="w-full grid md:grid-cols-2 gap-2 content-center"
          >
            <p class="text-left">No se encontraron históricos registrados.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseDownload from "../../../../components/UI/BaseInput/BaseDownload.vue";
import DetailCardHead from "../../../../components/UI/DetailCardHead.vue";
import $consumeService from "@/feature/historical/data/services/historical_impl";

export default {
  components: { BaseDownload, DetailCardHead },
  data() {
    return {
      isLoading: true,
      status: "text-yellow-300",
      legend: "Descargar",
      form: {
        first_name: "",
        last_name: "",
        tipo_id_CF: "",
        tipo_id_cf_name: "",
        numero_id_CF: "",
        birth_date: "",
        address: "",
        phone: "",
        email: "",
        department_name: "",
        municipio_name: "",
        creation_date: "",
        historical: [],
      },
      valuesStatus: [
        { value: "Abierta", color: "text-yellow-300" },
        { value: "Cerrada", color: "text-green-500" },
      ],
      optionsAboutRequest: [
        { id: 1, name: "Aceptada" },
        { id: 2, name: "Rechazada" },
      ],
      downloadUrl: "",
      isOpenManagerRequest: true,
      isOpenRequest: true,
      isOpenHistorical: true,
    };
  },
  mounted() {
    $consumeService
      .getHistoricalConsumDetail(this.$route.params.id)
      .then(({ data }) => {
        // Formatear creation_date en cada histórico
        if (Array.isArray(data.data.historical)) {
          data.data.historical = data.data.historical.map((h) => ({
            ...h,
            creation_date: h.creation_date
              ? h.creation_date.replace("T", " ").split(".")[0]
              : "",
          }));
        }
        this.form = data.data;
        this.form.creation_date = this.form.creation_date
          .replace("T", " ")
          .split(".")[0];
      });
  },
  methods: {
    toggleAccordionManagerRequest() {
      this.isOpenManagerRequest = !this.isOpenManagerRequest;
    },
    toggleAccordionRequest() {
      this.isOpenRequest = !this.isOpenRequest;
    },
    toggleAccordionHistorical() {
      this.isOpenHistorical = !this.isOpenHistorical;
    },
    viewDetail(id) {
      this.$router.push(
        `/dashboard/users/historical/${this.$route.params.id}/${id}`
      );
    },
  },
  watch: {},
};
</script>

<style>
#view-detail {
  width: 50%;
}
#view-detail button {
  font-size: 14px !important;
}
@media (max-width: 768px) {
  #view-detail {
    width: 100%;
  }
}
</style>
